/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs */

const en_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event group not found`)
};

const fr_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements introuvable`)
};

const de_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe nicht gefunden`)
};

const it_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi non trovato`)
};

const ru_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий не найдена`)
};

const es_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos no encontrado`)
};

const zh_cn2_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到事件组`)
};

const ja_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループが見つかりません`)
};

const hi_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह नहीं मिला`)
};

const pt_pt2_iframe_remote_export_event_group_not_found_error = /** @type {(inputs: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos não encontrado`)
};

/**
* | output |
* | --- |
* | "Event group not found" |
*
* @param {Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_export_event_group_not_found_error = /** @type {((inputs?: Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Export_Event_Group_Not_Found_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "de") return de_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "it") return it_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "ru") return ru_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "es") return es_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "ja") return ja_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "hi") return hi_iframe_remote_export_event_group_not_found_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_export_event_group_not_found_error(inputs)
	return en_iframe_remote_export_event_group_not_found_error(inputs)
});